import {styled} from "@mui/material/styles";

export const HighlightedBox = styled('div')(({theme}) => `
    background: #f4f6f7;
    border-radius: ${theme.shape.borderRadius};
    padding: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(.5)};
`,
);